var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.8,137.1c0.4,0.3,0.8,0.6,1.2,1l47.5,47.5c3.2,3.2,3.2,8.6,0,11.9c-3.2,3.3-8.6,3.3-11.8,0.1l0,0L138.2,150 c-0.4-0.4-0.7-0.8-1-1.2c-15,12.3-33.8,19-53.2,19C37.6,167.8,0,130.3,0,84S37.6,0,83.9,0s83.9,37.5,83.9,83.9 C167.8,104.1,160.7,122.6,148.8,137.1z M83.9,151c37,0,67.1-30,67.1-67.1c0-37-30-67.1-67.1-67.1l0,0c-37,0-67.1,30.1-67.1,67.1 C16.9,121,46.9,151,83.9,151z",
    fill: "#a3a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico-search.209bf31ffba32c58870c963675fbcb1c.svg";
export { ForwardRef as ReactComponent };